import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useClass } from "../../globals/ClassContext";
import { useAssignment } from "../../globals/AssignmentContext";
import axios from "axios";
import Dayjs from "dayjs";
import { useSetAssignmentReview } from "../../globals/AssignmentReviewContext";
const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function AssignmentSubmissions(props) {
  const classroom = useClass();
  const students = classroom.students;
  const assignment = useAssignment();
  const { setPage } = props;

  const [studentObjects, setStudentObjects] = React.useState([]);

  React.useEffect(() => {
    const fetchStudents = async () => {
      let data = [];
      if (students.length > 0 && typeof students[0] === "string") {
        const requests = students.map((id) =>
          axios.get(`${REACT_APP_DEBUGGER_SERVER_URL}/user/${id}`)
        );
        const responses = await axios.all(requests);
        data = responses.map((response) => response.data);
      } else {
        data = students;
      }

      data.sort((a, b) => a.name.localeCompare(b.name, "en"));

      setStudentObjects(data);
    };
    fetchStudents();
  }, [classroom, assignment]);

  return (
    <Stack divider={<Divider flexItem />}>
      <Box p={1}>
        <Typography variant="h4">{assignment.name}</Typography>
        <Typography variant="subtitle2">
          Due {Dayjs(assignment.due_date).format("MMMM D, YYYY")} at{" "}
          {Dayjs(assignment.due_date).format("h:mm A")}
        </Typography>
        <Typography variant="subtitle2">
          Open {Dayjs(assignment.open_date).format("MMMM D, YYYY")} at{" "}
          {Dayjs(assignment.open_date).format("h:mm A")}
        </Typography>
      </Box>
      {studentObjects.map((student) => (
        <Submission
          key={student._id}
          student={student}
          assignment={assignment}
          setPage={setPage}
        />
      ))}
    </Stack>
  );
}

function Submission(props) {
  const { student } = props;
  const { assignment } = props;
  const { setPage } = props;
  const setAssignmentReview = useSetAssignmentReview();
  const attempts = student.assignment_attempts;

  let grade = "N/A";
  let attemptObject = null
  attempts.forEach((attempt) => {
    if (attempt.assignment === assignment._id) {
      const points = attempt.pointsEarned ?? 0
      grade = "" + points + "/" + assignment.points;
      attemptObject = attempt
    }
  });


  const viewSubmission = () => {
    const assignmentReview = {
      userID: student._id,
      assignmentID: assignment._id,
    };
    setAssignmentReview(() => assignmentReview);
    setPage("assignmentReview");
  };

  return (
    <Card
      component={Paper}
      elevation={3}
      sx={{
        minheight: 55,
        "&:hover": {
          backgroundColor: "rgb(183,193,211)",
        },
      }}
      aligncontent="center"
      justifycontent="center"
      //change to the editor page with the assignment
    >
      <CardActionArea onClick={viewSubmission}>
        <CardContent>
          <Grid
            container
            //spacing={1}
            //justifyContent = "center"
            //alignItems = "center"
          >
            <Grid item xs alignSelf="center">
              <Typography align="left">{student.name}</Typography>
            </Grid>
            {attemptObject != null && (
              <Grid item xs alignSelf="center">
              {(attemptObject.isCompleted) && <Typography align="center">View Submission</Typography> }
              {(!attemptObject.isCompleted) && <Typography align="center">View Attempt Progress</Typography> }
              </Grid>
            )}
            <Grid item xs alignSelf="center">
              <Typography align="right">{grade}</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
